import { Fade, Popover, Slide, createTheme } from "@mui/material";
import { forwardRef, useContext } from "react";
import { LocaleContext } from "../../../routing/LangRouter";

const Transition = forwardRef(function Transition(props, ref) {
    const width = window.innerWidth;
    const breakpoint = 900;
    return width < breakpoint ? <Slide direction="up" ref={ref} {...props} /> : <Fade ref={ref} {...props} />;
});

function BasePopover({ children, id, open, anchorEl, handleClose, width, vertical, horizontal, radius }) {
    const { locale } = useContext(LocaleContext);
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        },
    });

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: vertical,
                horizontal: horizontal,
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: locale === "en" ? "left" : "right",
            }}
            TransitionComponent={Transition}
            sx={{
                "& .MuiPopover-paper": {
                    padding: "15px",
                    borderRadius: radius || "0.5rem",
                    boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)",
                    maxHeight:"50%",
                    [theme.breakpoints.between("xs", "md")]: {
                        position: "fixed",
                        bottom: 0,
                        left: "0 !important",
                        right: 0,
                        top: "auto !important",
                        maxWidth: "100%",
                    },
                },
                "& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper": {
                    width: `${width} !important`,
                    [theme.breakpoints.between("md", "lg")]: {
                        width: `${parseInt(width) + 10}% !important`,
                    },
                    [theme.breakpoints.between("xs", "md")]: {
                        width: "100% !important",
                    },
                },
            }}
        >
            {children}
        </Popover>
    );
}

export default BasePopover;
